import React from 'react'
import { Link } from 'react-router-dom'
import { HorizontalStack, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import { ProductTooltipPopOver } from '../ProductTooltipPopOver'
import type { ProductWidgetProps } from '@ztechapps/webui.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import type { RouteDef } from '@ztechapps/common.contract'

export const ProductWidget = ({ title, code, canEdit, _id }: ProductWidgetProps) => {
  const productRoute = useInject<RouteDef>(WebuiIocKey.routes.productItem)

  const linkTo = productRoute?.altPath?.({ _id })

  return (
    <TooltipPopOver tooltipBody={title}>
      <Stack direction="horizontal" gap={2}>
        <Stack>
          <HorizontalStack>
            <ProductTooltipPopOver productId={_id} canEdit={canEdit}>
              <span>
                <ShowIf condition={!!linkTo}>
                  <Link className="fw-bold" to={linkTo}>
                    {code}
                  </Link>
                </ShowIf>
                <ShowIf condition={!linkTo}>{code}</ShowIf>
              </span>
            </ProductTooltipPopOver>
          </HorizontalStack>
        </Stack>
      </Stack>
    </TooltipPopOver>
  )
}
